import { cn } from "@/lib/utils";
import type { LonerValue } from "../types";
import { LONER_VALUES } from "../constants";
import { useLanguage } from "../i18n";

export interface LonerSelectProps {
  enabled: boolean;
  value: LonerValue;
  onEnabledChange: (enabled: boolean) => void;
  onValueChange: (value: LonerValue) => void;
  className?: string;
}

export function LonerSelect({
  enabled,
  value,
  onEnabledChange,
  onValueChange,
  className,
}: LonerSelectProps) {
  const { t } = useLanguage();

  return (
    <div
      className={cn(
        "flex items-center gap-2",
        "text-sm px-3 py-1.5 transition-all",
        "bg-bb-gray-mid border border-bb-gray-mid",
        "hover:border-bb-blood-red",
        enabled && "border-bb-gold bg-bb-gold/20",
        className
      )}
    >
      <label className="flex items-center gap-2 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onEnabledChange(e.target.checked)}
          className="h-3.5 w-3.5 cursor-pointer accent-bb-gold"
        />
        <span className="text-bb-bone-white">{t.loner}</span>
      </label>
      <select
        value={value}
        onChange={(e) => onValueChange(parseInt(e.target.value, 10) as LonerValue)}
        className={cn(
          "px-2 py-0.5 text-sm",
          "bg-bb-gray-dark border border-bb-gray-mid rounded",
          "text-bb-bone-white",
          "focus:border-bb-gold focus:outline-none"
        )}
        disabled={!enabled}
      >
        {LONER_VALUES.map((v) => (
          <option key={v} value={v}>
            {v}+
          </option>
        ))}
      </select>
    </div>
  );
}
